var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagclosered({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15zm1.989-8.511a.562.562 0 1 0-.796-.796L8 7.386 6.807 6.193a.562.562 0 1 0-.796.796l1.193 1.193-1.193 1.193a.562.562 0 1 0 .796.796L8 8.977l1.193 1.194a.562.562 0 1 0 .796-.796L8.795 8.182 9.99 6.989z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagclosered);
export default __webpack_public_path__ + "static/media/tagclosered.c5734d50587a43fadaebdc4964c52578.svg";
export { ForwardRef as ReactComponent };